// extracted by mini-css-extract-plugin
module.exports = {"s1kmdyhg":"s1kmdyhg","color-pink":"color-pink","disabled":"disabled","selected":"selected","loading":"loading"};